enum CalendarWidth {
  DEFAULT = 'default-width',
  FULL_WIDTH = 'full-width',
}

enum DatePickerType {
  DROP_DOWN = 'dropdown',
  MODAL = 'modal',
}

enum TimePickerModal {
  NONE = 'none',
  START_TIME = 'start-time',
  END_TIME = 'end-time',
}

enum PrimaryButtonLabel {
  APPLY = 'Apply',
  CLEAR = 'Clear',
}

enum TimeMeridiem {
  AM = 'AM',
  PM = 'PM',
}

enum DatePickerValidataionStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
enum CalendarYearDropdownType {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export {
  DatePickerType,
  TimePickerModal,
  PrimaryButtonLabel,
  CalendarWidth,
  TimeMeridiem,
  DatePickerValidataionStatus,
  CalendarYearDropdownType,
};
